import Api from '../Api'
import store from '@/store/store'

export default {
    // READ ALL - Mes logements
    getAllHousings() {
        return Api().post('habitation/myhouse', {
            userid: store.state.user._id
        })
    },

    // CREATE - Créer un logement
    createHousing(housingData) {
        return Api().post('habitation/save', {
            userid: store.state.user._id,
            ...housingData
        })
    },

    // UPDATE - Modifier un logement
    updateHousing(id, housingData) {
        return Api().put('habitation/edit', {
            habitationid: id,
            ...housingData
        })
    },

    // DELETE - Supprimer un logement
    deleteHousing(id) {
        return Api().post('habitation/delete', {
            habitationid: id
        })
    }
}
